/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Mark_LostInputs */

const cs_deals_mark_lost = /** @type {(inputs: Deals_Mark_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit jako prohraný`)
};

const en_deals_mark_lost = /** @type {(inputs: Deals_Mark_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as lost`)
};

/**
* | output |
* | --- |
* | "Mark as lost" |
*
* @param {Deals_Mark_LostInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_mark_lost = /** @type {((inputs?: Deals_Mark_LostInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Mark_LostInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_mark_lost(inputs)
	return cs_deals_mark_lost(inputs)
});